export default carousel()

function carousel (){
    if(document.body) init()
    else document.addEventListener('DOMContentLoaded', ()=>{
        init()
    })
}

const init = ()=>{
    let carousels = [...document.querySelectorAll('.wp-block-wpblocks-carousel')]
    carousels.map(c => {
        new Carousel(c)
    })
}

class Carousel {

    constructor(element) {
        this.element = element

        this.children = [...this.element.children]

        this.index = 0
        this.drag = false
        this.dragStartX = null
        this.dragLength = 100
        this.timeOut = parseInt(this.element.getAttribute('data-time'))

        this.lastMove = Date.now()
        this.isAuto = true

        this.nextSlideTime = Date.now() + this.timeOut

        this.build()
        this.bind()

        this.loop()
    }

    build(){
        this.container = document.createElement('ul')
        this.container.className = 'carousel-slides'

        this.element.appendChild(this.container)

        this.children.map(child => {
            let slide = document.createElement('li')
            slide.className = 'carousel-slide'
            slide.appendChild(child)
            this.container.appendChild(slide)
        })

        this.container.style.width = `${this.children.length}00%`
        this.container.style.transform = `translate(0, 0)`;


        this.navigation = document.createElement('nav')
        this.navigation.className = 'carousel-navigation'
        this.element.appendChild(this.navigation)

        if(this.children.length <= 1) this.navigation.style.display = 'none'

        this.prevButton = document.createElement('span')
        this.nextButton = document.createElement('span')
        this.prevButton.className = 'carousel-prev'
        this.nextButton.className = 'carousel-next'
        this.navigation.appendChild(this.prevButton)
        this.navigation.appendChild(this.nextButton)

        this.element.style.height = this.container.getBoundingClientRect().height + 'px'
        this.element.style.transform = `height 0.2s ease-out`

        this.resize()
    }

    bind(){

        /**
         * Bind resize when slider imgs load
         */
        let imgs = [...this.element.querySelectorAll('img')]
        imgs.map(img => {
            img.addEventListener('load', (e)=>{
                this.resize()
            })
        })

        window.addEventListener('resize', ()=>{ this.resize() })

        this.prevButton.addEventListener('click', ()=>{ this.prev() })
        this.nextButton.addEventListener('click', ()=>{ this.next() })

        let down = (e)=>{
            let { currentTarget, pageX } = e
            if(!pageX) pageX = e.touches[0].pageX
            if(currentTarget == this.prevButton || currentTarget == this.nextButton) return false;
            this.pause()
            this.drag = true
            this.dragStartX = pageX
        }
        this.container.addEventListener('mousedown', down)
        this.container.addEventListener('touchstart', down)

        let move = (e)=>{
            let {pageX} = e
            if(!pageX) pageX = e.touches[0].pageX
            if(!this.drag) return false
            let delta = this.dragStartX - pageX
            if(Math.abs(delta) < this.dragLength) return false;
            if(delta > 0) this.next()
            else this.prev()
        }
        this.container.addEventListener('mousemove', move)
        this.container.addEventListener('touchmove', move)

        let up = ()=>{
            this.play()
            this.drag = false
        }
        this.container.addEventListener('mouseup', up)
        this.container.addEventListener('touchend', up)

        this.container.addEventListener('mouseover', ()=>{
            this.pause()
        })
        this.container.addEventListener('mouseout', ()=>{
            this.play()
        })
    }

    navigate(index){
        this.lastMove = Date.now()
        if(index < 0 ) index = this.children.length - 1;
        if(index >= this.children.length) index = 0;
        this.index = index
        this.drag = false
        this.container.style.transform = `translate(-${index / this.children.length * 100}%, 0)`
        this.resize()
    }
    next(){
        this.navigate(this.index+1)
    }
    prev(){
        this.navigate(this.index-1)
    }

    play(){
        this.isAuto = true
    }
    pause(){
        this.isAuto = false
    }
    loop(){
        setInterval(()=>{
            if(
                this.isAuto
                && this.lastMove <= Date.now() - this.timeOut
            ) this.next()
        }, this.timeOut + 1)
    }

    resize(){
        this.container.style.height = this.children[this.index].getBoundingClientRect().height + 'px'
        this.element.style.height = this.children[this.index].getBoundingClientRect().height + 'px'
    }

}